import { Injectable } from '@angular/core';
import Intercom from '@intercom/messenger-js-sdk';
@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  private isInitialized = false;

  initializeIntercom(user: { id: string, name: string, email: string, createdAt: number }) {
    if (!this.isInitialized) {
      this.loadIntercomScript().then(() => {
        this.setupIntercom(user);
        this.isInitialized = true;
      }).catch(error => console.error('Failed to load Intercom script:', error));
    } else {
      this.setupIntercom(user);
    }
  }

  shutdownIntercom() {
    if (typeof window.Intercom === 'function') {
      window.Intercom('shutdown');
    } else {
      console.error('Intercom is not defined');
    }
  }

  private loadIntercomScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://widget.intercom.io/widget/s6qqnv85';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Intercom script'));
      document.head.appendChild(script);
    });
  }

  private setupIntercom(user: { id: string, name: string, email: string, createdAt: number }) {
    window.intercomSettings = {
      app_id: 's6qqnv85',
      user_id: user.id,
      name: user.name,
      email: user.email,
      created_at: Math.floor(user.createdAt / 1000),
    };

    (function() {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', window.intercomSettings);
      } else {
        var d = document;
        var i: any = function() { i.c(arguments); };
        i.q = [];
        i.c = function(args: any) { i.q.push(args); };
        w.Intercom = i;
        var l = function() {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/s6qqnv85';
          var x = d.getElementsByTagName('script')[0];
          if (x && x.parentNode) {
            x.parentNode.insertBefore(s, x);
          }
        };
        if (d.readyState === 'complete') {
          l();
        } else {
          if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      }
    })();
  }
}
